import React from "react";

import PanelTitle from "components/PanelTitle";

export const Panel = ({ className, children }) => {
  return (
    <div
      className="panel panel-default"
      style={{ borderColor: "#d5d5d5", borderTop: "7px solid #0068b4" }}
    >
      {children}
    </div>
  );
};

export const PanelHeader = ({ title, children }) => {
  return (
    <div
      className="panel-heading clearfix"
      style={{
        backgroundColor: "#e4e4e4",
        backgroundImage: "none",
        borderColor: "#d5d5d5",
      }}
    >
      {title && <PanelTitle title={title} />}
      {children}
    </div>
  );
};
